"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _rebass = require("rebass");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Button = (0, _styledComponents.default)(_rebass.Button)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  cursor: pointer;\n  font-family: ", ";\n  font-weight: bold;\n  line-height: 1em;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition-duration: 0.3s;\n  transition-property: color, background-color;\n\n  :hover {\n    text-decoration: none;\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  font-family: ", ";\n  font-weight: bold;\n  line-height: 1em;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition-duration: 0.3s;\n  transition-property: color, background-color;\n\n  :hover {\n    text-decoration: none;\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fonts.mrEaves;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.white;
});
Button.defaultProps = {
  as: 'button',
  bg: 'white',
  borderColor: 'orange',
  borderStyle: 'solid',
  borderWidth: '3px',
  borderRadius: 0,
  color: 'orange',
  fontSize: 5,
  fontWeight: 'normal',
  px: 5,
  py: 3
};
Button.displayName = 'Button';
var _default = Button;
exports.default = _default;
var templateObject_1;